// Yönetici adresi şemasız yazdığında ("forms.gle/abc") tarayıcı bunu göreli
// yol sayar ve buton ssi.org.tr/forms.gle/abc adresine gider. Dış adreslerde
// şema yoksa https:// ekliyoruz.

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const SAFE_SCHEMES = /^(https?|mailto|tel):/i;

export const normalizeExternalUrl = (url) => {
  if (!url || typeof url !== 'string') return '';

  const trimmed = url.trim();
  if (!trimmed) return '';

  if (HAS_SCHEME.test(trimmed)) {
    // javascript: gibi şemaları dışarıda bırakıyoruz.
    return SAFE_SCHEMES.test(trimmed) ? trimmed : '';
  }

  return `https://${trimmed}`;
};

export default normalizeExternalUrl;
